import { RunningExperiments, useExperiments } from 'state/experiments';

export const useSignInUpAfterCartExperiment = () => {
  const { variant } = useExperiments();

  return variant(RunningExperiments.SignInUpAfterCart, 'treatment', { skipExposureLogging: true });
};
